import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@coval/ui"

import { MULTI_RUN_LIMIT } from "../utils/urlState"

export function ReportRunLimitDialog({
  itemLabel = "runs",
  onCancel,
  onContinue,
  open,
  source = "selection",
}: {
  itemLabel?: "runs" | "simulations"
  onCancel: () => void
  onContinue: () => void
  open: boolean
  source?: "filters" | "selection"
}) {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Report limit</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {source === "filters" ? (
            <p>
              More than {MULTI_RUN_LIMIT} runs match this report source. The
              report will include the first {MULTI_RUN_LIMIT} runs in the
              current sort order.
            </p>
          ) : (
            <p>
              More than {MULTI_RUN_LIMIT} {itemLabel} are selected. The report
              will include the first {MULTI_RUN_LIMIT} {itemLabel} in the
              current table order.
            </p>
          )}
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onContinue}>Continue</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
